import React, { useEffect } from "react";
import { MainRouter } from "./router";

import UserInfoContextProvider from "./contexts/userInfo";
import ReactGA from "react-ga4";
import "styles/typoGraphy.css";
import "styles/index.css";
import GlobalStyle from "./styles/globalStyles";
import { env } from "./.env";

function App() {
  ReactGA.initialize(`${env.REACT_APP_GOOGLE_ANALYTICS_TRACK_ID}`);

  return (
    <>
      <GlobalStyle />
      <UserInfoContextProvider>
        <MainRouter />
      </UserInfoContextProvider>
    </>
  );
}

export default App;
